import { render, staticRenderFns } from "./WardImportUtility.vue?vue&type=template&id=8dcb21ca&scoped=true&"
import script from "./WardImportUtility.vue?vue&type=script&lang=js&"
export * from "./WardImportUtility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcb21ca",
  null
  
)

export default component.exports